import React, { useState } from "react";
import Button from "../../../../components/ui/Button/Button";
import Modal from "../../../../components/ui/Modal/Modal";

const ApprovalActionModal = ({
  submitText,
  cancelText,
  description,
  triggerButton,
  confirmApproveMessage,
  confirmRejectMessage,
  onSubmit,
  onRefuse,
}) => {
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [pendingAction, setPendingAction] = useState(null);

  const openConfirm = (action) => {
    setPendingAction(action);
    setConfirmOpen(true);
  };

  const closeConfirm = () => {
    setConfirmOpen(false);
    setPendingAction(null);
  };

  const handleConfirm = () => {
    if (pendingAction === "approve") {
      onSubmit?.();
    } else if (pendingAction === "reject") {
      onRefuse?.();
    }
    closeConfirm();
  };

  return (
    <>
      <Modal
        submitText={submitText}
        cancelText={cancelText}
        description={description}
        onSubmit={() => openConfirm("approve")}
        onCancel={() => openConfirm("reject")}
      >
        {triggerButton}
      </Modal>
      <Modal
        isOpenFromOutside={confirmOpen}
        setIsOpenFromOutside={setConfirmOpen}
        description={
          <p className="text-[12px]">
            {pendingAction === "approve"
              ? confirmApproveMessage
              : confirmRejectMessage}
          </p>
        }
        onSubmit={handleConfirm}
        onCancel={closeConfirm}
        submitText="확인"
        cancelText="취소"
        hasClose={false}
        closable={false}
        maxWidth="max-w-[20rem]"
      >
        <span className="hidden" aria-hidden="true" />
      </Modal>
    </>
  );
};

const PopupCancelOrder = (props) => {
  const {
    isSubmit = true,
    isExchange,
    isReturn,
    data,
    onSubmit,
    onRefuse,
  } = props;

  const cancelDescription = (
    <div className="text-[11px] mb-1">
      <p className="mb-3">
        해당 상품의 주문 취소요청이 접수되었습니다. 취소승인을 하시겠 습니까?
      </p>
      [유의사항 안내] ‘취소상세’ 먼저 확인 필요
      <br />
      1. 취소승인
      <br />
      (1) 신용카드 : 카드사 취소 승인은 영업일 기준에 따라 다름
      <br />
      (2) 무통장입금 : ‘취소승인’후, ‘환불 예정 금액’을 입금하신 후에 최종 취소
      <br />
      승인 처리됨
      <br />
      2. 취소거부
      <br />
      주문취소가 거부되어 송장번호 입력이 가능
      <br />
    </div>
  );

  const exchangeDescription = (
    <div className="text-[11px] mb-1">
      <p className="mb-3">
        해당 상품의 교환요청이 접수되었습니다. 교환승인을 하시겠 습니까?
      </p>
      [유의사항 안내] ‘교환상세’ 먼저 확인
      <br />
      1. 교환승인 : 교환배송(반송)단계로 전환
      <br />
      (고객에게 물품을 받고 확인 후에 [등록]눌러 출고처리)
      <br />
      2. 교환거부
      <br />
      교환요청이 거부되어, 최종적으로 구매확정 처리
      <br />
    </div>
  );

  const returnDescription = (
    <div className="text-[11px] mb-1">
      <p className="mb-3">
        해당 상품의 반품요청이 접수되었습니다. 반품승인을 하시겠 습니까?
      </p>
      [유의사항 안내] ‘반품상세’ 먼저 확인
      <br />
      1. 반품승인 : 반품배송(반송)단계로 전환
      <br />
      (고객에게 물품을 받고 확인 후에 반품완료를 처리)
      <br />
      2. 반품완료 : 결제방법에 따른 2가지 환불 방법 안내
      <br />
      (1) 신용카드 : 카드사 취소 승인은 영업일 기준에 따라 다름
      <br />
      (2) 무통장입금 : ‘반품승인’후, ‘환불 예정 금액’을 입금하신 후에 최종 취소
      <br />
      승인 처리됨
      <br />
      3. 반품거부
      <br />
      반품요청이 거부되어, 최종적으로 구매확정 처리
    </div>
  );

  return (
    <div>
      <div className="mt-4 px-4 text-[12px]">
        <p className="font-bold text-[13px]">요청사유</p>
        <input
          type="text"
          disabled
          value={data?.productOrderComplaintReason?.name}
          className="border outline-none border-border-grey p-1.5 rounded-[4px] w-full mt-2 bg-white"
        />
      </div>
      <div className="mt-4 px-4 text-[12px]">
        <p className="font-bold text-[13px]">상세사유</p>
        <textarea
          type="text"
          rows={7}
          value={data?.description}
          disabled
          className="border outline-none border-border-grey resize-none p-1.5 rounded-[1px] w-full mt-2 bg-white"
        />
      </div>
      <div className="my-4 text-[12px] px-4">
        <p className="font-bold mb-1 text-[13px]">첨부 파일 목록</p>
        <div className="h-[9rem] overflow-auto">
          {data?.images?.map((item, index) => (
            <a
              key={`${item}-${index}`}
              rel="noopener noreferrer"
              className="text-bold-blue underline"
              href={item}
            >
              {item.split("/").pop()}
            </a>
          ))}
        </div>
      </div>
      <div className="border-t flex px-4 pt-4 border-t-disable-grey">
        <div
          className={`${
            isSubmit || isExchange || isReturn ? "w-full" : "w-[50%]"
          } mr-2`}
        >
          {data?.images?.length > 0 ? (
            <Modal
              hasCancel={false}
              description={<div className="px-2">다운로드 되었습니다.</div>}
            >
              <Button text={`전체 다운로드`} width="w-full" />
            </Modal>
          ) : null}
        </div>
        {isSubmit && (
          <div className={`w-full`}>
            <ApprovalActionModal
              submitText="취소승인"
              cancelText="취소거부"
              description={cancelDescription}
              confirmApproveMessage="정말 취소승인하시겠습니까?"
              confirmRejectMessage="정말 취소거부하시겠습니까?"
              onSubmit={onSubmit}
              onRefuse={onRefuse}
              triggerButton={
                <Button
                  text={`취소요청`}
                  textColorDefault="text-white"
                  bgColor="bg-primary-blue"
                  borderColor="border border-primary-blue"
                  width="w-full"
                />
              }
            />
          </div>
        )}
        {isExchange && (
          <div className={`w-full`}>
            <ApprovalActionModal
              submitText="교환승인"
              cancelText="교환거부"
              description={exchangeDescription}
              confirmApproveMessage="정말 교환승인하시겠습니까?"
              confirmRejectMessage="정말 교환거부하시겠습니까?"
              onSubmit={onSubmit}
              onRefuse={onRefuse}
              triggerButton={
                <Button
                  text={`교환요청`}
                  textColorDefault="text-white"
                  bgColor="bg-primary-blue"
                  borderColor="border border-primary-blue"
                  width="w-full"
                />
              }
            />
          </div>
        )}
        {isReturn && (
          <div className={`w-full`}>
            <ApprovalActionModal
              submitText="반품승인"
              cancelText="반품거부"
              description={returnDescription}
              confirmApproveMessage="정말 반품승인하시겠습니까?"
              confirmRejectMessage="정말 반품거부하시겠습니까?"
              onSubmit={onSubmit}
              onRefuse={onRefuse}
              triggerButton={
                <Button
                  text={`반품요청`}
                  textColorDefault="text-white"
                  bgColor="bg-primary-blue"
                  borderColor="border border-primary-blue"
                  width="w-full"
                />
              }
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default PopupCancelOrder;
